import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Enlightenment_&_Revolutions_-_Latin_American_Wars_of_Independence.png';

function HistoryPageLatinAmericanWars() {
  return (
    <TopicPage
      topicKey="Latin American Wars of Independence"
      title="History: Latin American Wars of Independence"
      backgroundImage={bg}
      startRoute="/History-Latin-American-Wars-Go"
      scrollLabels={[
        "Simón Bolívar & José de San Martín",
        "Regional Struggles",
        "Independence Achieved"
      ]}
      backRoute="/history-age-of-revolutions"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageLatinAmericanWars;
